<template>
  <div style="height: 100%" :class="theme == 1 ? 'white' : 'black'">
    <!-- <van-nav-bar
            title="产品详情"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
    />-->
    <!-- <div v-if="isFullScreen == 2" :style="{
        paddingTop: statusBarHeight,
        height: navigationBarHeight,
        background: backgroundColor,
      }"></div> -->
    <van-nav-bar
      v-if="isFullScreen == 2"
      :class="theme == 2 ? 'textColor1' : 'textColor'"
      :style="{
        marginTop: statusBarHeight,
        height: navigationBarHeight,
        background: backgroundColor,
      }"
      :title="title"
      left-text=""
      right-text=""
      :placeholder="false"
      left-arrow
      :safe-area-inset-top="true"
      @click-left="onClickLeft"
    />
    <div class="product-main">
      <!-- <div class="product-info">
                <div class="title">{{product.name}}</div>
                <div class="summary">{{product.summary}}</div>
      </div>-->
      <img
        v-if="product.thumbnailUrl"
        :src="picHost + product.thumbnailUrl"
        width="100%"
      />
      <div
        v-if="product.priceType == 1"
        class="product-desp"
        style="margin-bottom: 100px"
      >
        <p v-html="product.bigContent"></p>
      </div>
      <div
        v-if="product.priceType == 2"
        class="product-desp"
        style="margin-bottom: 100px"
      >
        <p v-html="product.bigContent"></p>
      </div>
    </div>
    <div v-if="product.priceType == 2">
      <div class="sub-boot" v-if="!sub" style="padding: 8px 16px">
        <van-button type="info"  round @click="goPayPage(false)" color="#F44336" block
          >立即开通</van-button
        >
        <span class="agreement">
          开通表示您同意
          <a href="javascript:;" @click="goAgreementPage" style="color: #3395ff"
            >《启明星增值服务协议》</a
          >
        </span>
      </div>
      <div class="sub-boot" v-if="sub" style="padding: 8px 16px 16px 16px">
        <van-button type="info"  round color="#F44336" block @click="goInfoPage"
          >已开通</van-button
        >
        <span class="agreement">
          服务{{ product.subscribe.endDate }}到期
          <a
            href="javascript:;"
            @click="goPayPage(true)"
            style="color: #3395ff; margin-left: 10px"
            >立即续费</a
          >
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar, Image, Button, Toast } from "vant";
import MallServiceApi from "@/api/mall";
import { getUrlParams } from "@/utils/utility";
import moment from "moment";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");
import inobounce from "inobounce";
var picHost = process.env.VUE_APP_PIC_BASE_URL;
export default {
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },

  data() {
    return {
      product: {},
      productId: null,
      type: null,
      picHost: picHost,
      sub: false,
      theme: "1",
      updateTime: "",
      isFullScreen: 0,
      statusBarHeight: "",
      navigationBarHeight: "",
      backgroundColor: "rgba(0, 0,0 ,0)",
      top100: 1,
      navopacity: 0,
      title: "",
    };
  },

  mounted() {
    var that = this;
    if (userAgent.android) {
      this.$bridge.registermethod("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge((bridge) => {
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            sessionStorage.setItem("theme", responseData);
          }
        );
      });
    }
  },
  activated() {
    this.theme = sessionStorage.getItem("theme");
  },
  created() {
    this.productId = getUrlParams("id");
    this.type = getUrlParams("type");
    this.isFullScreen = getUrlParams("isFullScreen");
    if (sessionStorage.getItem("theme") == 2) {
      this.theme = 2;
      this.backgroundColor = "rgba(0, 0,0 ,1)";
    } else {
      this.theme = 1;
      this.backgroundColor = "rgba(255, 255,255 ,1)";
    }
    let u = navigator.userAgent;
    if (u.indexOf("iPhone") > -1) {
      inobounce.enable();
    }
    this.statusBarHeight = this.$route.query.statusBarHeight + "px";
    this.navigationBarHeight = this.$route.query.navigationBarHeight + "px";
    //  if (sessionStorage.getItem("Access-Token")) {
    this.getProductInfo();
    // }
    this.addDate();
    sessionStorage.removeItem("index");
    sessionStorage.removeItem("payNo");
     sessionStorage.removeItem("url");
  },
  beforeDestroy() {
    inobounce.disable();
  },
  methods: {
    CompareDate(d1, d2) {
      return new Date(d1.replace(/-/g, "/")) <= new Date(d2.replace(/-/g, "/"));
    },
    addDate() {
      const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };
      const newmonth = date.month > 10 ? date.month : "0" + date.month;
      const day = date.date > 10 ? date.date : "0" + date.date;
      this.updateTime = date.year + "-" + newmonth + "-" + day;
    },
    getProductInfo() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      let that = this;
      MallServiceApi.getProductInfo({
        productCategoryId: that.type,
        id: that.productId,
      }).then((res) => {
        // console.log(res);
        Toast.clear();
        if (res.code == 200) {
          document.title = res.data.name;
          this.title = res.data.name;
          that.product = res.data;
          if (that.product != null && that.product.subscribe != null) {
            if (
              that.product.subscribe.type == 2 &&
              that.product.subscribe.relatedId == 1
            ) {
              that.sub = true;
            } else if (
              this.CompareDate(that.updateTime, that.product.subscribe.endDate)
            ) {
              that.sub = true;
            }
          }
        } else if (res.code == 401) {
          setTimeout(() => {
            that.getProductInfo();
          }, 1000);
        }
      });
    },
    onClickLeft() {
      if (userAgent.android) {
        this.$bridge.callmethod("closeContainer");
      } else {
        window.WebViewJavascriptBridge.callHandler(
          "closeContainer",
          function (responseData) {}
        );
      }
    },
    goAgreementPage() {
      var query = {
        name: this.product.name,
        theme: this.theme,
      };
      this.$router.push({ path: "/xieyi", query: query });
    },
    goPayPage(isRenewal) {
      var query = {
        type: this.type,
        id: this.productId,
        theme: this.theme,
      };
      if (isRenewal) {
        query.isRenewal = true;
      }
      sessionStorage.setItem("productId", this.productId);
        
      sessionStorage.setItem("producttype", this.type);
      this.$router.push({ path: "/pay", query: query });
    },
    goInfoPage() {
      if (this.product.type == 1) {
        if (this.product.webUrl == null) {
          return;
        }
        console.log(this.product.webUrl);
        var urlList = JSON.parse(JSON.parse(this.product.webUrl));
        // console.log(JSON.parse(urlList))
        var url = urlList[0].url;
        console.log(url);
        urlList.forEach((item) => {
          if (item.webType == "1") {
            url = item.url;
          }
        });
        window.location.href =
          url +
          "?webkey=" +
          localStorage.getItem("webkey") +
          "&theme=" +
          this.theme +
          "&userId=" +
          sessionStorage.getItem("userId") +
          "&token=" +
          sessionStorage.getItem("Access-Token");
      } else if (this.product.type == 2) {
        if (userAgent.android) {
          this.$bridge.callmethod("webPushNative", {
            action: "curricukum",
            param: { curriculumId: item.relatedId },
          });
        } else {
          window.WebViewJavascriptBridge.callHandler(
            "webPushNative",
            { action: "curricukum", param: { curriculumId: item.relatedId } },
            function (responseData) {}
          );
        }
      } else if (this.product.type == 3) {
      }
    },
  },
};
</script>
<style lang='less' scoped>
.white {
  background: #eeeff4;
  color: #333;
  .sub-boot {
    background: #fff;
  }
}
.black {
  color: #676d78;
  background: #121620;

  .sub-boot {
    background: #171c27;
    color: #f0f1f4;
  }
}
.product-desp {
  // padding: 0 16px;
  ::v-deep {
    img,
    p,
    span {
      width: 100% !important;
      height: auto !important;
      padding: 0px !important;
    }
  }
}

.sub-boot {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px;
  text-align: center;
}

.product-main {
  position: absolute;
  overflow: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.product-info {
  margin: 10px 0;
}

.product-info .title {
  text-align: center;
}

.product-info .summary {
  text-align: center;
  font-size: 12px;
}

.sub-boot .agreement {
  display: block;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
}
.textColor {
  /deep/.van-nav-bar__title {
    color: #333 !important;
  }
  /deep/.van-icon {
    color: #333;
  }
}
.textColor1 {
  /deep/.van-nav-bar__title {
    color: #fff !important;
  }
  /deep/.van-icon {
    color: #fff !important;
  }
}
.search {
  height: 1.57rem;
  /deep/.van-nav-bar .van-icon {
    color: #000000;
  }
}
</style>